<p-dialog
        header="Kampagne klonen"
        [(visible)]="visible"
        [modal]="true"
        (onHide)="closeDialog()"
        [style]="{ width: '520px' }"
        contentStyleClass="p-0">

    @if (visible && campaign) {
        <div class="p-4 flex flex-column gap-4">

            <!-- Source Campaign Info -->
            <div class="surface-100 border-round p-3">
                <div class="text-sm text-secondary mb-1">Klonen von:</div>
                <div class="font-semibold">{{ campaign.name }}</div>
                <div class="flex gap-2 mt-2">
                    <p-tag [value]="campaignTypeLabel" severity="info" [rounded]="true"></p-tag>
                    <p-tag [value]="campaignModeLabel" severity="secondary" [rounded]="true"></p-tag>
                </div>
            </div>

            <!-- Clone Name -->
            <div class="flex flex-column gap-1">
                <label class="font-medium text-sm">
                    Klonname
                </label>

                <input
                        pInputText
                        [(ngModel)]="form.name"
                        [placeholder]="namePlaceholder"
                        class="w-full"
                        [ngClass]="{ 'p-invalid': isNameInvalid }"
                        maxlength="255"
                />

                <small class="text-secondary">
                    Leer lassen, um den Namen automatisch zu generieren
                </small>

                <small *ngIf="isNameInvalid" class="text-red-500">
                    Name darf 255 Zeichen nicht überschreiten
                </small>
            </div>

            <!-- Clone Description -->
            <div class="flex flex-column gap-1">
                <label class="font-medium text-sm">
                    Beschreibung
                </label>

                <textarea
                        pInputTextarea
                        [(ngModel)]="form.description"
                        [placeholder]="campaign.description || 'Beschreibung eingeben...'"
                        class="w-full"
                        [rows]="3"
                        [ngClass]="{ 'p-invalid': isDescriptionInvalid }"
                        maxlength="2000"
                ></textarea>

                <small *ngIf="isDescriptionInvalid" class="text-red-500">
                    Beschreibung darf 2000 Zeichen nicht überschreiten
                </small>
            </div>

            <!-- Clone Options -->
            <div class="flex flex-column gap-2">
                <label class="font-medium text-sm">Klonoptionen</label>

                <div class="flex flex-column gap-3 surface-50 border-round p-3">

                    <!-- Selection Criteria -->
                    <div class="flex align-items-center gap-2">
                        <p-checkbox
                                [(ngModel)]="form.cloneSelectionCriteria"
                                [binary]="true"
                                inputId="cloneSelectionCriteria">
                        </p-checkbox>
                        <label for="cloneSelectionCriteria" class="cursor-pointer">
                            <span class="font-medium">Selektionskriterien klonen</span>
                            <div class="text-sm text-secondary">
                                Alle Regelgruppen und Bedingungen einschließen
                            </div>
                        </label>
                    </div>

                    <!-- Refresh Schedule (only for Rolling campaigns) -->
                    <div class="flex align-items-center gap-2" [class.opacity-50]="!isRollingCampaign">
                        <p-checkbox
                                [(ngModel)]="form.cloneRefreshSchedule"
                                [binary]="true"
                                inputId="cloneRefreshSchedule"
                                [disabled]="!isRollingCampaign">
                        </p-checkbox>
                        <label for="cloneRefreshSchedule" class="cursor-pointer">
                            <span class="font-medium">Aktualisierungsplan klonen</span>
                            <div class="text-sm text-secondary">
                                @if (isRollingCampaign) {
                                    Zeitplaneinstellungen kopieren (startet inaktiv)
                                } @else {
                                    Nur für fortlaufende Kampagnen verfügbar
                                }
                            </div>
                        </label>
                    </div>

                    <!-- Assignment Rules -->
                    <div class="flex align-items-center gap-2">
                        <p-checkbox
                                [(ngModel)]="form.cloneAssignmentRules"
                                [binary]="true"
                                inputId="cloneAssignmentRules">
                        </p-checkbox>
                        <label for="cloneAssignmentRules" class="cursor-pointer">
                            <span class="font-medium">Zuweisungsregeln klonen</span>
                            <div class="text-sm text-secondary">
                                Agenten-Zuweisungskonfigurationen einschließen
                            </div>
                        </label>
                    </div>
                </div>
            </div>

            <!-- Info Message -->
            <div class="flex align-items-start gap-2 surface-100 border-round p-3">
                <i class="pi pi-info-circle text-primary mt-1"></i>
                <div class="text-sm">
                    Die geklonte Kampagne wird im Status <strong>Entwurf</strong> erstellt,
                    <strong>ohne Mitglieder</strong>. Mitglieder werden bei Aktivierung der Kampagne hinzugefügt.
                </div>
            </div>

        </div>

        <div class="flex justify-content-end gap-2 p-3 border-top-1 surface-border">

            <p-button
                    label="Abbrechen"
                    severity="secondary"
                    [text]="true"
                    (onClick)="cancel()"
                    [disabled]="busy">
            </p-button>

            <p-button
                    label="Kampagne klonen"
                    icon="pi pi-copy"
                    [disabled]="!isFormValid || busy"
                    [loading]="busy"
                    (onClick)="submit()">
            </p-button>

        </div>
    }
</p-dialog>
